module.exports = __webpack_public_path__ + "static/code1-bd5cf018bbcd2bc225d7820fec009463.png";